const BOOK_ADDED = 'redux/books/BOOK_ADDED';
const BOOK_REMOVED = 'redux/books/BOOK_REMOVED';
const CHECKED_BOOK_STATUS = 'redux/categories/CHECKED_BOOK_STATUS';

export default {
  BOOK_ADDED,
  BOOK_REMOVED,
  CHECKED_BOOK_STATUS,
};
